import { useState, useEffect } from 'react';
import exampleTemplates from '../services/innovatech/exampleTemplates.json';

/**
 * Hook para cargar ejemplos de cualquier laboratorio/sección
 * @param {string} labId - ID del laboratorio (ej: 'lab1')
 * @param {string} sectionId - ID de la sección (ej: 'bml_build.mvp_descripcion')
 * @returns {Object} { examples, isLoading, error }
 */
export const useExampleTemplates = (labId, sectionId) => {
  const [examples, setExamples] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log(`🔍 [Hook] Loading examples for ${labId}.${sectionId}`);
    console.log('🔍 [Hook] Full data structure:', exampleTemplates);
    console.log('🔍 [Hook] Lab1 data:', exampleTemplates.labs?.lab1);
    
    try {
      // Navegar la estructura del JSON
      let data = exampleTemplates.labs[labId];
      console.log('🔍 [Hook] Lab data:', data);
      
      // Si sectionId contiene punto, navegar usando dot notation
      if (sectionId.includes('.')) {
        const pathParts = sectionId.split('.');
        console.log('🔍 [Hook] Using dot notation for parts:', pathParts);
        for (const part of pathParts) {
          if (data && data[part]) {
            data = data[part];
          } else {
            throw new Error(`Section ${sectionId} not found in ${labId} - missing part: ${part}`);
          }
        }
      } else {
        // Si no tiene punto, acceder directamente
        console.log('🔍 [Hook] Direct access to section:', sectionId);
        console.log('🔍 [Hook] Available sections:', Object.keys(data || {}));
        
        if (data && data[sectionId]) {
          data = data[sectionId];
          console.log('🔍 [Hook] Found section data:', data);
        } else {
          throw new Error(`Section ${sectionId} not found in ${labId}`);
        }
      }
      
      setExamples(data);
      setError(null);
      console.log('✅ [Hook] Successfully loaded examples:', data);
    } catch (err) {
      console.warn(`❌ [Examples] Could not load examples for ${labId}.${sectionId}:`, err);
      setError(err.message);
      setExamples(null);
    } finally {
      setIsLoading(false);
    }
  }, [labId, sectionId]);

  return { examples, isLoading, error };
};

export default useExampleTemplates;